import { Box, Typography } from '@mui/material';
import { t } from 'i18next';
import OpenElisDashboard from 'images/OpenElisDashboard.png';
export default function OpenElisLogInDetails() {
  return (
    <Box px={2} py={2}>
      <Typography variant='h5' align='center' mb={2}>{t('openelisdashboardText', { ns: ['home'] })}</Typography>
      <img src={OpenElisDashboard} style={{ width: '98vw' }} />
    </Box>
  );
}
